// Push Registration to Mailchimp
var myCounter = 0;
jQuery(document).ready(function() {
    setTimeout(function(){
        getMailchimpData();
    },2000);
    
    registerToMailchimp();

    var full = window.location.host;
    var parts = full.split('.');
    var sub = parts[0];

    if ('eu' == sub) {
        sub = 'EU';
    } else if ('uk' == sub) {
        sub = 'United Kingdom';
    } else if ('us' == sub) {
        sub = 'usa';
    } else if ('au' == sub) {
        sub = 'Australia';
    } else {
        sub = 'other';
    }

    jQuery('#contact_form').append('<input type="hidden" value="' + sub + '" name="customer[note][country]">');
});

function registerToMailchimp() {
    _submitAllowed = false;

    // Despite being an ID, actually multiple of these forms per page
    var form = jQuery('#create_customer, #contact_form');
    if (form.length) {
        form.submit(function(e) {
            var currentForm = jQuery(this);
            currentForm
            $(this).find('input[type=submit]').val("Creating Your Account…");
            $(this).find('input[type=submit]').prop('disabled', true);
            sendData($(this), currentForm, 0, e);

        });
    }
}

function sendData(element, currentForm, myCounter, e) {
	
  	var full = window.location.host;
    var parts = full.split('.');
    var sub = parts[0];

    if ('eu' == sub) {
        sub = 'EU';
    } else if ('uk' == sub) {
        sub = 'United Kingdom';
    } else if ('us' == sub) {
        sub = 'usa';
    } else if ('au' == sub) {
        sub = 'Australia';
    } else {
        sub = 'other';
    }
  
    var storelist = {
        'customer[note][deal_from_minetan]': 'https://marqueofbrands.us11.list-manage.com/subscribe/post-json?u=be57ffb606b089a7050632028&amp;id=767d9a6f0c&c=?',
        'customer[note][deal_from_taneasy]': 'https://marqueofbrands.us11.list-manage.com/subscribe/post-json?u=be57ffb606b089a7050632028&amp;id=cd1b8b7fba&c=?',
        'customer[note][deal_from_btan]': 'https://marqueofbrands.us11.list-manage.com/subscribe/post-json?u=be57ffb606b089a7050632028&amp;id=2729700605&c=?',
        'customer[note][deal_from_pure]': 'https://marqueofbrands.us11.list-manage.com/subscribe/post-json?u=be57ffb606b089a7050632028&amp;id=dff3548dd0&c=?',
        'customer[note][deal_from_plabel]': 'https://marqueofbrands.us11.list-manage.com/subscribe/post-json?u=be57ffb606b089a7050632028&amp;id=24d53e1b2c&c=?',
    };
    var sendUrls = [];
    var count = 0;
    $($(element).find('.select-brands li')).each(function(index, val) {
        if ($(val).find('input').is(':checked')) {
            var name = $(val).find('input').attr('name');
            var mailchimpUrl = encodeURIComponent(storelist[name]);
            sendUrls.push(mailchimpUrl);
            count++;
        }
    });
    if ($(element).attr('id') == 'contact_form') {
        mailchimpUrl = encodeURIComponent("https://marqueofbrands.us11.list-manage.com/subscribe/post-json?u=be57ffb606b089a7050632028&amp;id=767d9a6f0c&c=?");
        sendUrls.push(mailchimpUrl);
        count++;
    }

    if (count != 0) {
        $(element).find('input[type=submit]').val("Creating Your Account…");
        $(element).find('input[type=submit]').prop('disabled', true);
    }
    
    var EMAIL  =  $(element).find("input[name='customer[email]']").val();
    var MERGE12 = $(element).find("input[name='customer[tags]']").val();
    var MMERGE11 = 'EURO';
    var data = {'EMAIL':EMAIL,'MERGE12':MERGE12,'MMERGE11':MMERGE11,'MMERGE10':sub};
    data = JSON.stringify(data);    
    var totalUrl = sendUrls.length;

    allUrls = JSON.stringify(sendUrls);
    if (_submitAllowed == false) {
        e.preventDefault();
        createCookie('mailchimp',allUrls);
        createCookie('data',data);
        _submitAllowed = true;
        setTimeout(function() {
           currentForm.submit();
        }, 2000);

    }
}

function createCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function eraseCookie(name) {
    createCookie(name, "", -1);
}


/*
* get mailchimp pending records
*/
function getMailchimpData()
{
    var mailchimp = readCookie('mailchimp');
    var data = readCookie('data');
    mailchimp = $.parseJSON(mailchimp);
    
    if(typeof mailchimp == "undefined" ||  mailchimp == null) {
            eraseCookie('data');
            return false;
    }
    if(mailchimp.length == 0) {
        eraseCookie('data');
        return false;
    }

    var totalReq = mailchimp.length; 
    addInMailchimp(mailchimp,data,totalReq,0);
    

}   

/**
* this function send request to mailchimp for add new user
*/
function addInMailchimp(urls,data,totalReq,counter)
{
    if(typeof  urls[counter] == 'undefined' || typeof urls[counter] == null || urls[counter] == '') {
        counter++;
    }
    console.log(data);
    jQuery.ajax({
        type: 'GET',
        crossDomain: true,
        url: decodeURIComponent(decodeURIComponent(urls[counter])),
        data: $.parseJSON(data),
        async: false,
        dataType: 'jsonp',
        success: function(response) {
            if (counter == totalReq - 1) {
                var allUrls = {};
                if(response.result != 'error'  || response.msg.indexOf('already subscribed') != -1) {
                    urls.splice(counter, 1);
                    var newUrls = JSON.stringify(urls);
                    console.log(newUrls);
                    createCookie('mailchimp',newUrls);
                }
                   
            } else {
                counter++;
                setTimeout(function() {
                    var  prev =  counter - 1;
                    console.log(response.result);
                    if(response.result != 'error' || response.msg.indexOf('already subscribed') != -1) {
                        urls.splice(prev, 1);
                        var newUrls = JSON.stringify(urls);
                        console.log(newUrls);
                        createCookie('mailchimp',newUrls);
                    }
                    
                    addInMailchimp(urls, data, totalReq, counter);
                }, 6000);
            }
        }
    });
}